import { useFormContext, useWatch } from 'react-hook-form';

import { TaxCalculationMethod as TaxCalculationMethods } from '@xemplo/gp-types';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

const taxCalcItems = Object.values(TaxCalculationMethods).map((item) => ({
  key: item,
  value: item,
}));

export const TaxCalculationMethod = () => {
  const { control } = useFormContext<FormFields>();
  const lumpSum = useWatch({ control, name: 'lumpSum' });
  const taxCalcList = useListBuilder(taxCalcItems);

  if (!lumpSum || lumpSum === 'No') return;

  return (
    <S.FormLabel>
      Tax calculation method
      <V2.TextDropdownRhf
        name="taxCalculationMethod"
        items={taxCalcList}
        placeholder="Select method"
        data-testid="taxCalculationMethod"
        aria-label="Tax calculation method field"
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
};
